import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from 'react-select';
import { useMediaQuery } from 'react-responsive'
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';

export const ResultsList = ({ items, activeParcel, selectResultItem }) => {
    const isSmallScreen = useMediaQuery({ query: '(max-width: 959px)' })
	const { t } = useTranslation("tracking");
    const formatResultOption = (item) => ({ value: item.id, index: item.index || 0, label: item.id, status: item?.statusHistory[0]?.statusText, date: item?.statusHistory[0]?.date})
    const [selectedPackageIdx, setSelectedPackageIdx] = useState(formatResultOption(items[0]));
    // useEffect(() => {
    //     activeParcel && setSelectedPackageIdx(formatResultOption(activeParcel));
    // }, [activeParcel])
    const options = items.map((itemObj, i) => ({ value: itemObj.id, index: i, label: itemObj.id, status: itemObj?.statusHistory[0]?.statusText, date: itemObj?.statusHistory[0]?.date} ));
    const formatOptionLabel = ({ value, index, label, status, date }) => (
        <div className="results-dropdown">
          <div className="title">{index+1}. {label}</div>
          <div className="details">
            {status}, {date}
          </div>
        </div>
      );
    const handleDropdownChange = (e) => {
        selectResultItem(e.index);
        setSelectedPackageIdx(e)
    }
	return (
		<>
			<h3 className="results-heading">{t("results")}</h3>
            { isSmallScreen && ( 
                <div className="results-dropdown-wrap">
                    <Select
                        // className='results-dropdown'
                        classNamePrefix="results-dropdown"
                        options={options || []}
                        placeholder={t('Package')}
                        value={{...selectedPackageIdx}}
                        onChange={handleDropdownChange}
                        formatOptionLabel={formatOptionLabel}
                    
                    />
                </div>
            ) || (
                <ul className="results-list">
                    {items.map((item, i) => (
                        <li className={`result-item ${item?.id === activeParcel?.id ? "active": ''}`} key={`resultitem${i}`}>
                            <button onClick={() => selectResultItem(i)}>
                                <div className="title">
                                    {i + 1}. {item?.id}
                                    {item?.publicRemark && (<ErrorOutlineOutlinedIcon fontSize="medium" color="action" />)}
                                </div>
                                <div className="details">{`${item?.statusHistory[0]?.statusText}, ${item?.statusHistory[0]?.date}`}</div>
                            </button>
                        </li>
                    ))}
                </ul>
            )

            }
		</>
	);
};
